/**
 *
 * Asynchronously loads the component for RatingCriteriaTextHelper
 *
 */

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./index'),
  loading: () => null,
});



// WEBPACK FOOTER //
// ./src/ui/components/rating-criteria-text-helper/loadable.js